import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
// import { storeToRefs } from "pinia";
// import { cartStore } from "@/stores/Store";
// let mycart = cartStore();
// let user = storeToRefs(mycart);

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  // var list = JSON.parse(localStorage.getItem("userlist"));
  // if (list.account != "") {
  //   mycart.user = list;
  //   mycart.logintoken = true;
  //   // console.log("刷新了 token為true");
  //   console.log(mycart.logintoken);
  //   console.log(list);
  // } else {
  //   mycart.logintoken = false;
  //   // console.log("刷新了 但是token為false");
  // }
  // console.log("我刷新重新进来了");
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})